import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Component, ElementRef, ViewChild, AfterViewInit } from "@angular/core";
import { AgEditorComponent } from "@bfx/ag-grid-angular";

@Component({
  selector: "time-editor",
  templateUrl: "./html/TimeEditor.html",
  standalone: false,
})
export class TimeEditor implements AgEditorComponent {
  public params: any;
  public isBuy: boolean = false;
  public editingEnabled: boolean = false;
  public title: string = null;
  public isCall: boolean = false;
  public spun: boolean = false;

  public hour: string = "00";
  public minute: string = "00";
  public second: string = "00";

  @ViewChild("hours", { static: true })
  public hoursElement: ElementRef;

  @ViewChild("minutes", { static: true })
  public minutesElement: ElementRef;

  @ViewChild("seconds", { static: true })
  public secondsElement: ElementRef;

  getValue(): any {
    let val: CubiqTS.Moment = CubiqTS.moment(
      this.hour + ":" + this.minute + ":" + this.second,
      CubiqTS.moment.HTML5_FMT.TIME_SECONDS,
    );

    if (this.params.context != null && this.params.context.setEditedValue != null) {
      this.params.value = val;
      this.params.context.setEditedValue(val, this.params);
      val = this.params.value;
    }

    return val;
  }

  afterGuiAttached(): void {
    this.hoursElement.nativeElement.focus();
    setTimeout(
      (() => {
        this.hoursElement.nativeElement.select();
      }).bind(this),
      10,
    );
  }

  // called on init
  agInit(params: any): void {
    this.params = params;

    if (params.context != null && params.context.isCellEditingEnabled) {
      this.editingEnabled = params.context.isCellEditingEnabled(params);
    }

    if (params.value != null) {
      let val: string = params.value.format("HH:mm:ss");
      let values: string[] = val.split(":");
      this.hour = values[0];
      this.minute = values[1];
      this.second = values[2];
    }

    [this.hoursElement, this.minutesElement, this.secondsElement].forEach((element: ElementRef) => {
      element.nativeElement.setAttribute("original", element.nativeElement.value);
    });
  }

  isCancelBeforeStart?(): boolean {
    return !this.editingEnabled;
  }

  isCancelAfterEnd?(): boolean {
    return !this.editingEnabled;
  }

  public onKeyDown(event: any): void {
    switch (event.which) {
      case 38: // Up
      case 40: // Down
        this.spun = true;
        break;
      case 37: // Left
        event.preventDefault();
        event.stopPropagation();

        if (event.target == this.secondsElement.nativeElement) {
          this.minutesElement.nativeElement.focus();
          this.minutesElement.nativeElement.select();
        }

        if (event.target == this.minutesElement.nativeElement) {
          this.hoursElement.nativeElement.focus();
          this.hoursElement.nativeElement.select();
        }
        break;
      case 39: // Right
        event.preventDefault();
        event.stopPropagation();
      case 9: // Tab
        if (event.target == this.hoursElement.nativeElement) {
          event.preventDefault();
          event.stopPropagation();
          this.minutesElement.nativeElement.focus();
          this.minutesElement.nativeElement.select();
        }

        if (event.target == this.minutesElement.nativeElement) {
          event.preventDefault();
          event.stopPropagation();
          this.secondsElement.nativeElement.focus();
          this.secondsElement.nativeElement.select();
        }
        break;
    }
  }

  public onFocus(event: any): void {
    if (event && event.target) {
      event.target.select();
    }
  }

  public onBlur(event: any): void {
    [this.hoursElement, this.minutesElement, this.secondsElement].forEach((element: ElementRef) => {
      let strValue: string = element.nativeElement.value;
      strValue = strValue.trim().length == 0 ? 0 + "" : strValue;
      let value: number = parseInt(strValue, 10);
      element.nativeElement.value = value < 10 ? ("0" + value).substring(0, 2) : value;
    });
  }

  public onInput(event: any): void {
    let value: string = event.target.value;
    let spun: boolean = this.spun;

    const trimValue = value.trim();

    if (trimValue.length > 0) {
      let num: number = parseInt(value, 10);
      let maxValue: number = parseInt(event.target.getAttribute("max"));
      if (num > maxValue || num < 0) {
        event.target.value = event.target.getAttribute("original");
      } else {
        event.target.setAttribute("original", value);

        if (trimValue.length == 2 && !spun) {
          if (event.target == this.hoursElement.nativeElement) {
            this.minutesElement.nativeElement.focus();
            this.minutesElement.nativeElement.select();
          } else if (event.target == this.minutesElement.nativeElement) {
            this.secondsElement.nativeElement.focus();
            this.secondsElement.nativeElement.select();
          }
        } else if (trimValue.length == 1 && spun) {
          event.target.value = "0" + trimValue;
        }
      }
    }
    this.spun = false;
  }
}
